import { createMuiTheme } from "@material-ui/core";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

export const fonts = {
  sans: 'Roboto, FreeSans, "Liberation Sans", sans-serif',
  serif: "Georgia, serif",
};

// Generate breakpoints so we can use them in the theme definition
const breakpoints = createBreakpoints({});

// Example of extending theme
declare module "@material-ui/core/styles/createMuiTheme" {
  interface ThemeOptions {
    custom: {
      color: string;
    };
    fonts: {
      serif: string;
      sans: string;
      [key: string]: string;
    };
  }
}

declare module "@material-ui/core/styles/createPalette" {
  interface PaletteColor {
    background?: string;
    backgroundDark?: string;
    backgroundLight?: string;
    white?: string;
    textLight?: string;
  }

  interface SimplePaletteColorOptions {
    background?: string;
    backgroundDark?: string;
    backgroundLight?: string;
    white?: string;
    textLight?: string;
  }
}

export const customTheme = createMuiTheme({
  custom: {
    color: "#277A8A",
  },
  shape: {
    borderRadius: 0,
  },
  palette: {
    primary: {
      contrastText: "#000",
      dark: "#ffd402",
      light: "#ffff78",
      main: "#fbed42",
      A100: "rgba(251, 237, 66, 0.5)",
      white: "#fff",
      textLight: "#4a4a4a",
    },
    secondary: {
      contrastText: "#000",
      dark: "#1c5762", // currently not in design. Set as darken(#277a8a, 10%)
      light: "#7CB6C1",
      main: "#277a8a",
      background: "#dee8df",
      backgroundLight: "#eff5f6",
      backgroundDark: "#c3d5c5",
      white: "#fff",
    },
  },
  typography: {
    fontSize: 14,
    h4: {
      fontFamily: fonts.serif,
      color: "#000000",
      fontSize: 22,
      lineHeight: "1.5em",
    },
    h3: {
      fontFamily: fonts.serif,
      color: "#000000",
      fontSize: 20,
      fontWeight: 700,
      letterSpacing: 0.25,
      lineHeight: "1.5em",
    },
    h2: {
      fontFamily: fonts.serif,
      color: "#000",
      fontSize: 27,
      fontWeight: 700,
      lineHeight: "1.2em",
      marginBottom: "0.7em",
      [breakpoints.down("sm")]: {
        fontSize: 23,
        lineHeight: "1.2em",
      },
    },
    h1: {
      fontFamily: fonts.serif,
      color: "#000",
      fontSize: 32,
      fontWeight: 700,
      lineHeight: "1.5em",
      letterSpacing: "-0.75px",
      [breakpoints.down("sm")]: {
        fontSize: 24,
        lineHeight: "1.2em",
      },
    },
    h5: {
      color: "#000000",
      fontFamily: fonts.serif,
      fontSize: 16,
      fontWeight: 700,
      lineHeight: "1.5em",
    },
    h6: {
      fontFamily: fonts.serif,
      fontSize: 14,
      fontWeight: 700,
      lineHeight: "1.5em",
    },
    subtitle1: {
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: 16,
      fontWeight: 300,
      lineHeight: "1.2em",
      fontFamily: fonts.serif,
      margin: "10px 0 28px",
    },
  },
  // override native MUI's component style
  overrides: {
    MuiSvgIcon: {
      root: {
        width: 30,
        height: 30,
      },
    },
    MuiCheckbox: {
      root: {
        color: "#277A8A", // square border color,
        fontSize: 30, // square dimensions: default is 24px
      },
      // checked: {
      colorSecondary: {
        "&$checked": {
          color: "#277A8A", // fill color: MUI default is red
        },
      },
    },
    MuiButton: {
      contained: {
        borderRadius: 0, // removes MUI default
      },
      root: {
        lineHeight: "36px", // MUI default: 24px
      },
    },
    // the slider with the percentage
    MuiSlider: {
      root: {
        padding: "13px 0 !important",
      },
      // indicatore (palloncino)
      thumb: {
        color: "#FFD402",
        // in xs/sm (mobile) view viene nascosto il "palloncino"
        // giallo come sfondo, mostrato il mark grande
        [breakpoints.down("sm")]: {
          "&$disabled": {
            height: 32,
            width: 32,
            top: 0,
          },
        },
      },
      // la percentuale di avanzamento: mostrata sopra il mark e non sul palloncino
      valueLabel: {
        [breakpoints.down("sm")]: {
          top: 11,
          left: 0,
        },
        [breakpoints.up("md")]: {
          left: "calc(50% - 16px)",
        },
        "& *": {
          background: "#FFD402",
          color: "#000",
          fontWeight: "bold",
          fontFamily: fonts.sans,
          letterSpacing: 0,
          [breakpoints.down("sm")]: {
            background: "transparent", // palloncino di background non visibile
          },
        },
      },
      track: {
        color: "#FFD402",
      },
      // parte mancante (a dx dell'indicatore),
      rail: {
        color: "#FDF8D7", //#FFD402 con opacità = 0.38
      },
      // pallini degli step
      mark: {
        color: "#FDF8D7",
        // color: "#000000",
      },
      // valore dei mark
      markLabel: {
        visibility: "hidden",
      },
      // valore del mark attivo
      markLabelActive: {
        visibility: "hidden",
      },
      // oggetto che contiene il "track"
      marked: {
        marginBottom: 0,
        [breakpoints.down("sm")]: {
          marginBottom: 20,
          marginTop: 20,
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14,
        lineHeight: "16px",
        fontFamily: fonts.sans,
      },
    },
  },
  fonts,
});
